import { useUserDetails } from 'Contexts/UserDetailsContext'
import useService from 'Hooks/use-service'
import { useCallback } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { createAttempt } from 'Services/exams.service'

export const useCreateAttempt = () => {
    const userDetail = useUserDetails()
    const params = useParams()
    const location = useLocation()

    const { data, isLoading, error, trigger: triggerCreateAttempt } = useService(createAttempt)

    const createAndFetchAttempt = useCallback(() => {
        const attemptId = location.state?.attemptId
        if (attemptId || !userDetail || !params.examId) {
            return
        }
        return triggerCreateAttempt({ examId: params.examId, userId: userDetail.userID })
    }, [location.state?.attemptId, params.examId, triggerCreateAttempt, userDetail])

    return {
        data,
        error,
        isLoading,
        createAttempt: createAndFetchAttempt,
    }
}
